import { BehaviorSubject } from 'rxjs';

export default class PatientRepository {
  constructor({ patientService }) {
    this.patientService = patientService;
  }

  getPatientByEmail(email) {
    return this.patientService.getPatientByEmail(email);
  }

  getPatients(criteria) {
    return this.patientService.getPatients(criteria);
  }

  reinvitePatient(patient) {
    return this.patientService.reinvitePatient(patient);
  }

  getPatientRecords(criteria) {
    return this.patientService.getPatientRecords(criteria);
  }

  addStudy(payload, progress$ = new BehaviorSubject(0)) {
    return this.patientService.addStudy(payload, progress$);
  }

  getRecord(id) {
    return this.patientService.getRecord(id);
  }

  downloadFiles(id) {
    return this.patientService.downloadFiles(id);
  }

  removeFiles(id) {
    return this.patientService.removeFiles(id);
  }

  getPatientStudies() {
    return this.patientService.getPatientStudies();
  }

  getDowngradeRecords() {
    return this.patientService.getDowngradeRecords();
  }

  deleteRecords(idsToDelete) {
    return this.patientService.deleteRecords(idsToDelete);
  }

  downloadDowngradeFiles(recordIds) {
    return this.patientService.downloadDowngradeFiles(recordIds);
  }

  getViewerLink(recordId) {
    return this.patientService.getViewerLink(recordId);
  }

  getDownloadCompressedStudyLink(resourceId, token) {
    return this.patientService.getDownloadCompressedStudyLink(resourceId, token);
  }

  shareReportEmail(email, name, recordId) {
    return this.patientService.shareReportEmail(email, name, recordId);
  }

  viewReportFirstTime(recordId) {
    return this.patientService.viewReportFirstTime(recordId);
  }

  getVideoReportLink(recordId) {
    return this.patientService.getVideoReportLink(recordId);
  }

  getChildResourcesLink(recordId, token = '') {
    return this.patientService.getChildResourcesLink(recordId, token);
  }
}
